import React from "react";
import { FieldConfig, FieldSectionConfig } from "../../../../../models/Models";
import EditModal from "../modal/EditModal";
import { ContentGroup } from "../../../../../models/vod/Models";
import { useEditVodContentGroup } from "../../../../../services/vod/Query";

interface Props {
    modalId: string;
    contentGroup: ContentGroup;
}

const ContentGroupModal = ({ contentGroup, modalId }: Props) => {
    const editVodContentGroup = useEditVodContentGroup();
    const contentGroupFormConfig: FieldConfig<ContentGroup>[] = [
        { path: "title", label: "Title", type: "text" },
        {
            path: "classification",
            type: "group",
            fields: [
                { path: "categories", label: "Categories", type: "text", isArray: true },
                { path: "genres", label: "Genres", type: "text", isArray: true },
                { path: "keywords", label: "Keywords", type: "text", isArray: true },
            ],
        },
        {
            path: "summaries",
            type: "group",
            fields: [
                { path: "longSynopsis", label: "Long synopsis", type: "paragraph" },
                { path: "mediumSynopsis", label: "Medium synopsis", type: "paragraph" },
                { path: "shortSynopsis", label: "Short synopsis", type: "paragraph" },
            ],
        },
        {
            path: "releaseInfo",
            type: "group",
            fields: [
                { path: "yearOfRelease", label: "Year of Release", type: "number" },
                { path: "countriesOfOrigin", label: "Countries of Origin", type: "text", isArray: true },
            ],
        },
        {
            path: "parentalRatings",
            label: "Parental Ratings",
            type: "group",
            isArray: true,
            fields: [
                { path: "region", label: "Region", type: "text" },
                { path: "system", label: "System", type: "text" },
                { path: "label", label: "Label", type: "text" },
                { path: "advisories", label: "Advisories", type: "text", isArray: true },
            ],
        },
        {
            path: "castAndCrew",
            type: "group",
            fields: [
                { path: "actors", label: "Actors", type: "text", isArray: true },
                { path: "directors", label: "Directors", type: "text", isArray: true },
                { path: "producers", label: "Producers", type: "text", isArray: true },
            ],
        },
    ];
    const fieldSectionConfigs: FieldSectionConfig<ContentGroup>[] = [ {
        fields: contentGroupFormConfig,
    } ];

    return (
        <>
            <EditModal
                modalId={modalId}
                config = {fieldSectionConfigs}
                initialValues = {contentGroup}
                onSubmit = {async (data: ContentGroup) => {
                    await editVodContentGroup.mutateAsync(data);
                }}
            />
        </>
    );
};

export default ContentGroupModal;